// Logo ngân hàng — ảnh ở public/banks/ (tải từ cdn.vietqr.io, đã cắt bớt viền trắng).
// Luôn đặt trên nền trắng: vài logo có nền trắng liền, chế độ tối vẫn phải rõ.
// Ngân hàng chưa có logo thì hiện 3 chữ đầu.

import { cn } from '@/lib/utils'

const BASE = (import.meta.env.BASE_URL || '/').replace(/\/?$/, '/')

/** Tên ngân hàng (KNOWN_BANKS) → tên file trong public/banks/. */
const LOGO_FILES: Record<string, string> = {
  Vietcombank: 'vietcombank',
  Techcombank: 'techcombank',
  ACB: 'acb',
  'MB Bank': 'mbbank',
  BIDV: 'bidv',
  VietinBank: 'vietinbank',
  VPBank: 'vpbank',
  Sacombank: 'sacombank',
  TPBank: 'tpbank',
  HDBank: 'hdbank',
  SHB: 'shb',
  Agribank: 'agribank',
}

/** Kích thước + padding do chỗ dùng quyết định qua className (VD: "h-10 w-16 p-1.5"). */
export function BankLogo({ bank, className }: { bank: string; className?: string }) {
  const file = LOGO_FILES[bank]
  return (
    <span className={cn('inline-flex shrink-0 items-center justify-center rounded bg-white ring-1 ring-rule', className)}>
      {file ? (
        <img src={`${BASE}banks/${file}.png`} alt="" className="size-full object-contain" draggable={false} />
      ) : (
        <span className="text-xs font-bold tracking-wider text-info">{bank.slice(0, 3).toUpperCase()}</span>
      )}
    </span>
  )
}
